// src/pages/Contact.js
import React from 'react';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import ContactForm from '../components/contact/ContactForm';

const BusinessHours = () => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-white">Godziny otwarcia</h3>
    <div className="grid grid-cols-2 gap-2 text-gray-300">
      <div>
        <p>Poniedziałek - Piątek</p>
        <p>Sobota</p>
        <p>Niedziela</p>
      </div>
      <div>
        <p>9:00 - 18:00</p>
        <p>9:00 - 16:00</p>
        <p>nieczynne</p>
      </div>
    </div>
  </div>
);

const ContactInfo = () => (
  <div className="space-y-6">
    <div>
      <h3 className="text-xl font-semibold text-white mb-2">Kontakt</h3>
      <div className="space-y-2 text-gray-300">
        <p>Tel: <a href="tel:+48508198200" className="hover:text-primary-400 transition-colors">+48 508 198 200</a></p>
        <p>Email: <a href="mailto:mdclean@interia.pl" className="hover:text-primary-400 transition-colors">mdclean@interia.pl</a></p>
      </div>
    </div>

    <div>
      <h3 className="text-xl font-semibold text-white mb-2">Adres</h3>
      <a
        href="https://maps.app.goo.gl/MvMgHRTFvWa45bV89"
        target="_blank"
        rel="noopener noreferrer"
        className="block space-y-2 text-gray-300 hover:text-primary-400 transition-colors"
      >
        <p>Ignacego Matuszewskiego 11A</p>
        <p>80-288 Gdańsk</p>
      </a>
    </div>

    <BusinessHours />
  </div>
);

const Contact = () => {
  const [titleRef, isTitleVisible] = useIntersectionObserver();
  const [contentRef, isContentVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <div className="relative min-h-screen pt-20">
      {/* Tło */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/50 z-10" />
        <img
          src="https://images.unsplash.com/photo-1672840997353-4579d5d6a7d5?q=80&w=1932&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover object-center fixed"
          aria-hidden="true"
        />
      </div>

      {/* Zawartość */}
      <div className="relative z-20 container mx-auto px-4 py-12">
        {/* Nagłówek */}
        <div
          ref={titleRef}
          className={`
            text-center mb-12 transform transition-all duration-700 ease-out
            ${isTitleVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}
          `}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Kontakt
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Masz pytania? Skontaktuj się z nami lub odwiedź naszą myjnię
          </p>
        </div>

        {/* Grid z formularzem i informacjami */}
        <div
          ref={contentRef}
          className={`
            max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12
            transform transition-all duration-700 ease-out delay-300
            ${isContentVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}
          `}
        >
          {/* Formularz */}
          <div className="bg-black/30 backdrop-blur-sm p-6 md:p-8 rounded-2xl">
            <h2 className="text-2xl font-bold text-white mb-6">
              Napisz do nas
            </h2>
            <ContactForm />
          </div>

          {/* Informacje kontaktowe */}
          <div className="bg-black/30 backdrop-blur-sm p-6 md:p-8 rounded-2xl">
            <ContactInfo />
          </div>
        </div>

        {/* Mapa Google */}
        <div
          className={`
            max-w-6xl mx-auto mt-12
            transform transition-all duration-700 ease-out delay-500
            ${isContentVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}
          `}
        >
          <div className="bg-black/30 backdrop-blur-sm p-6 md:p-8 rounded-2xl">
            <h2 className="text-2xl font-bold text-white mb-6">
              Nasza lokalizacja
            </h2>
            <div className="w-full h-[500px] rounded-xl overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2324.7602661539486!2d18.583224200000004!3d54.3612172!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fd75392fa99b11%3A0xe52a19a93eb935a7!2sAuto%20Detailing%20Gda%C5%84sk%20%7C%20Naprawa%20Tapicerki%20Samochodowej%20%7C%20Renowacja%20Sk%C3%B3r%20%7C%20R%C4%99czna%20Myjnia%20Samochodowa%20%7C%20Pranie%20Tapicerki!5e0!3m2!1spl!2spl!4v1768211756880!5m2!1spl!2spl"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mapa lokalizacji Auto Detailing Gdańsk"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
